import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from './context/Context';

import 'react-quill/dist/quill.snow.css';
import './assets/styles/quill.scss';

// preload base64 audio once for global usage
import { base64Audio } from './constants';
const audio = new Audio(base64Audio);
window.messageAudio = audio;

const Page = () => {
  return (
      <Provider>
        <App />
      </Provider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('widget'));
root.render(<Page />);

reportWebVitals();
